import { StyleSheet } from "react-native-unistyles";

const stylesheet = StyleSheet.create(() => ({
  view: {
    _web: {
      maskImage: `linear-gradient(to top, transparent 0%, black 40%, transparent 100%)`,
    },
  },
  image: {
    width: "100%",
    height: "100%",
  },
}));

export default stylesheet;
